import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.infoText)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
      infoBanner: true,
      'infoBanner-bar': _ctx.variant === 'bar',
      'infoBanner-block': _ctx.variant === 'block'
    }),
        "data-testid": "infoBanner"
      }, [
        _createElementVNode("p", null, _toDisplayString(_ctx.infoText), 1)
      ], 2))
    : _createCommentVNode("", true)
}